import React from 'react';

interface C2PAIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const C2PAIcon: React.FC<C2PAIconProps> = ({ size = 24, color = 'currentColor', className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    x="0"
    y="0"
    version="1.1"
    viewBox="0 0 18 18"
    preserveAspectRatio="xMidYMid meet"
    width={size}
    height={size}
    className={className}
    style={{ fill: color }}
  >
    <path
      fillRule="evenodd"
      d="M14.6,8v6.6H8c-3.7,0-6.6-3-6.6-6.6s3-6.6,6.6-6.6S14.6,4.3,14.6,8z M0,8c0-4.4,3.6-8,8-8s8,3.6,8,8v8H8 C3.6,16,0,12.4,0,8z M3.2,8.3c0,1.6,1.1,3,2.9,3c1.5,0,2.4-1,2.7-2.2H7.3c-0.2,0.6-0.6,0.9-1.2,0.9c-0.9,0-1.5-0.7-1.5-1.8 s0.6-1.8,1.5-1.8c0.6,0,1,0.3,1.2,0.9h1.4C8.5,6.2,7.5,5.3,6.1,5.3C4.3,5.3,3.2,6.7,3.2,8.3z M10.7,5.4H9.3v5.8h1.4v-3 c0-0.6,0.2-0.9,0.4-1.2c0.2-0.2,0.6-0.3,1.1-0.3h0.4V5.4h-0.4c-0.8,0-1.2,0.3-1.6,0.7L10.7,5.4L10.7,5.4z"
      clipRule="evenodd"
    />
  </svg>
);
